AuthHandler = new Class({
    Binds: ["parseQueryString", "isSsoEnabled", "getSamlRequest", "processSamlRequest"],

    queryString: "",

    initialize: function() {
        var params = this.parseQueryString();
        var enabled = this.isSsoEnabled(params.sso);

        if (enabled && Librarian.features.sso.load)
            this.getSamlRequest();
        else {
            $$(".loginpanel").show();
            $$(".loadingMessage").hide();
        }
    },

    parseQueryString: function () {
        var search = (window.location.search || '').substring(1),
            hash = (window.location.hash || '');

        this.queryString = search + hash;

        return search.parseQueryString();
    },

    isSsoEnabled: function(ssoValue) {
        var enabled = Librarian.sso.enabledByDefault;
        if (window.location.host == "localhost")
            enabled = false;

        if (ssoValue)
            enabled = ssoValue.trim().toLowerCase() == "true";

        return enabled;
    },

    getSamlRequest: function() {
        var request = new Request.JSON({
            url: "SamlAuth.ashx?mode=getRequest&out=json",
            method: "get",
            noCache: true,
            onSuccess: this.processSamlRequest.bind(this)
        });

        request.send();
    },

    processSamlRequest: function(responseObj) {
        if (!responseObj || !responseObj.Target)
            return;

        var form = new Element("form", {
            method: "POST",
            action: responseObj.Target
        }).inject(document.body);

        var samlRequest = new Element("input[type=hidden]", {
            name: "SAMLRequest",
            value: responseObj.RequestString
        }).inject(form);

        var relayState = new Element("input[type=hidden]", {
            name: "RelayState",
            value: this.queryString
        }).inject(form);

        form.submit();
    }
});

window.addEvent("load", function() {
    Librarian.authHandler = new AuthHandler();
});